import React from 'react';
import PropTypes from 'prop-types';
import {confirmable} from 'react-confirm';
import Dialog from 'components/pure/utils/Dialog';
import Button from '@material-ui/core/Button';
import './AlertDialog.styl';

const AlertDialog = ({show, proceed, dismiss, confirmation, options, title = 'Alert'}) => (
  <Dialog
    title={<div key="title">{title}</div>}
    contentClassName="alert-dialog"
    closeButton={true}
    actions={[
      <Button variant="contained" color="primary" className="ev-button" onClick={proceed}>
        Ok
      </Button>,
    ]}
    open={show}
    onRequestClose={proceed}>
    {confirmation}
  </Dialog>
);

AlertDialog.propTypes = {
  show: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
  proceed: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
  dismiss: PropTypes.func, // from confirmable. call to only close the dialog.
  confirmation: PropTypes.string, // arguments of your confirm function
  options: PropTypes.object, // arguments of your confirm function
};

export default confirmable(AlertDialog);
